import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { authWithUsernamePassword } from '../../services/auth';
import { AuthContainer } from './AuthContainer';
import { useUserContext } from '../../context/user';
import { getFirebaseToken } from "../../firebase";
import { sendPushToken } from "../../services/notifications";
import { AuthType } from '../../types/auth';
import { LayoutType } from "../../types/common/layout";
import {Loading} from "../Loading";

export const SignInLoginPasswordForm = () => {
    const { setRole, setJwtToken, setJwtRefreshToken, setUserAuthType, setLayout } = useUserContext();
    const [username, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const { mutate: fcmToken } = useMutation({
        mutationFn: (data: { token: string, jwt: string }) => sendPushToken(data.token, data.jwt),
        onSettled: (data) => {
            // Сохраняем тип авторизации (для пин кода, т.к пин только для вошедших по номеру телефона)
            setUserAuthType(AuthType.LOGIN)

            // NOTE: Disable layout 
            handleSelectLayout('MANAGER')
            // NOTE: Disable layout

            // Перенаправляем на главную, после отправки запроса
            window.location.replace('/');
        }
    });

    // NOTE: Disable layout 
    const handleSelectLayout = (layout: LayoutType) => {
        setLayout(layout);
    }
    // NOTE: Disable layout 

    const {
        mutate: authenticate,
        isPending,
    } = useMutation({
        mutationFn: authWithUsernamePassword,
        onSuccess: (data) => {
            setIsLoading(true);
            setJwtToken(data.access);
            setJwtRefreshToken(data.refresh);
            setRole(data.role);
            // Если токен есть, то отправляем его на бэк
            getFirebaseToken().then(token => {
                if (token) {
                    fcmToken({ token, jwt: data.access });
                } else {
                    // Сохраняем тип авторизации (для пин кода, т.к пин только для вошедших по номеру телефона)
                    setUserAuthType(AuthType.LOGIN)

                    // NOTE: Disable layout 
                    handleSelectLayout('MANAGER')
                    // NOTE: Disable layout

                    // Перенаправляем на главную, после отправки запроса
                    window.location.replace('/');
                }
            })
        }
    });

    const submit: React.MouseEventHandler<HTMLButtonElement> = (event) => {
        event.preventDefault();
        if (username && password) {
            authenticate({ username, password });
        }
    };

    return (
        <AuthContainer>
            {isPending || isLoading ? <Loading /> :
                <div className="w-full">
                    <div
                        className="mb-8 font-manager-acrom-h4-24-medium-acrom font-[number:var(--manager-acrom-h4-24-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-h4-24-medium-acrom-font-size)] text-center tracking-[var(--manager-acrom-h4-24-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-h4-24-medium-acrom-line-height)] [font-style:var(--manager-acrom-h4-24-medium-acrom-font-style)]">
                        Авторизация по логину и паролю
                    </div>

                    <div
                        className="w-full flex flex-col font-manager-acrom-ph1-18-medium-acrom font-[number:var(--manager-acrom-ph1-18-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-ph1-18-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-18-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-18-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph1-18-medium-acrom-font-style)]">
                        <input
                            type="text"
                            placeholder='Логин'
                            onChange={e => setLogin(e.target.value)}
                            value={username}
                            className='bg-melon-light-grey rounded-lg h-12 text-center w-full  my-2'
                        />
                    </div>

                    <div
                        className="w-full flex flex-col font-manager-acrom-ph1-18-medium-acrom font-[number:var(--manager-acrom-ph1-18-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-ph1-18-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-18-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-18-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph1-18-medium-acrom-font-style)]">
                        <input
                            type="password"
                            placeholder='Пароль'
                            onChange={e => setPassword(e.target.value)}
                            value={password}
                            className='bg-melon-light-grey rounded-lg h-12 text-center w-full  my-2'
                        />
                    </div>
                    {/*<p className="text-red-500 text-sm mt-1 mb-2">*/}
                    {/*    {errorText}*/}
                    {/*</p>*/}
                    <div className="w-full flex flex-col justify-center items-center mt-4">
                        <button
                            onClick={submit}
                            className='w-full h-12 inline-flex items-center justify-center flex-[0_0_auto] rounded-lg gap-2.5 px-5 py-4 relative font-manager-acrom-ph1-18-medium-acrom font-[number:var(--manager-acrom-ph1-18-medium-acrom-font-weight)] text-[length:var(--manager-acrom-ph1-18-medium-acrom-font-size)] text-center tracking-[var(--manager-acrom-ph1-18-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-18-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-18-medium-acrom-font-style)] bg-melon-yellow'
                        >
                            Войти
                        </button>
                        <a
                            href="mailto:report@melonfashion.com"
                            className="mt-10 font-manager-acrom-links font-[number:var(--manager-acrom-links-font-weight)] text-black text-[length:var(--manager-acrom-links-font-size)] text-center tracking-[var(--manager-acrom-links-letter-spacing)] leading-[var(--manager-acrom-links-line-height)] underline whitespace-nowrap [font-style:var(--manager-acrom-links-font-style)]"
                        >Связаться с тех. поддержкой</a>
                    </div>
                </div>
            }
        </AuthContainer>
    );
};
